module.exports = __webpack_public_path__ + "static/media/angery-filly2.f92e703c.png";